import { enumify, Enumify } from '@mews/enumify';

type NotificationStateKeys = 'Pending' | 'Seen';

function NotificationState() {}
enumify<NotificationStateKeys, number>(NotificationState, 'NotificationState', {
    Pending: 0,
    Seen: 1,
});

export default NotificationState as unknown as Enumify<NotificationStateKeys, number>;
